import { createSlice } from "@reduxjs/toolkit";

//initial state
const initialAuthState = { isAuthenticated: false };

//authentication slice

const authSlice = createSlice({
  name: "authentication",
  initialState: initialAuthState,
  reducers: {
    login(state) {
      state.isAuthenticated = true;
    },
    logout(state) {
      state.isAuthenticated = false;
    },
  },
});

export const authActions = authSlice.actions;

export default authSlice.reducer;
